import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SubscriptionSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (sessionId) {
      checkStatus();
    }
  }, [sessionId, attempts]);

  const checkStatus = async () => {
    try {
      const { data } = await axios.get(`${API}/subscription/checkout-status/${sessionId}`, { withCredentials: true });
      if (data.payment_status === 'paid') {
        setStatus('paid');
      } else if (attempts < 10) {
        setTimeout(() => setAttempts(a => a + 1), 2000);
      } else {
        setStatus('timeout');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F7F3] flex items-center justify-center px-6 py-12">
      <div className="max-w-md w-full bg-white border border-[#E5E0D8] rounded-md p-12 shadow-[2px_2px_0px_rgba(26,26,26,0.08)] text-center">
        {status === 'checking' && (
          <>
            <div className="w-16 h-16 mx-auto mb-6 border-4 border-[#B94A3E] border-t-transparent rounded-full animate-spin" />
            <h1 className="text-2xl mb-2" style={{fontFamily: 'Spectral, serif'}}>Confirming your subscription...</h1>
            <p className="text-sm text-[#737373]">Please wait a moment.</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <CheckCircle2 className="w-16 h-16 mx-auto mb-6 text-green-600" strokeWidth={1.5} />
            <h1 className="text-3xl mb-4" style={{fontFamily: 'Spectral, serif'}}>Welcome aboard!</h1>
            <p className="text-[#737373] mb-8">Your subscription is now active. Start writing letters and creating memory photos.</p>
            <Link to="/dashboard">
              <Button className="bg-[#B94A3E] hover:bg-[#9d3e33] text-white w-full" data-testid="go-to-dashboard-btn">
                Go to Dashboard
              </Button>
            </Link>
          </>
        )}
        {status === 'timeout' && (
          <>
            <h1 className="text-2xl mb-4" style={{fontFamily: 'Spectral, serif'}}>Still processing...</h1>
            <p className="text-[#737373] mb-6">Your payment is being processed. Please check your dashboard shortly.</p>
            <Link to="/dashboard">
              <Button className="bg-[#B94A3E] hover:bg-[#9d3e33] text-white w-full">Go to Dashboard</Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
